




<template>





  <v-card


   >

    <v-toolbar
  height="42"
  color="#4A76A8"
  dark flat

>
<v-card-title     >
<span v-if="modals.creator" style="font-size:1.4em">  Новое автообновление  </span>
<span v-if="modals.params" style="font-size:1.4em">{{activeParams}}</span>

</v-card-title>
<v-spacer></v-spacer>

<v-icon v-if="modals.creator"  @click="modals.creator = false"> mdi-close</v-icon>
<v-icon v-if="modals.params"  @click="modals.params = false"> mdi-close</v-icon>
</v-toolbar>










    <v-snackbar
      v-model="sb.snackbar"
      :color="sb.color"
      center top
       absolute

      :timeout="2000"

    >
      {{ sb.text  }}
      <v-btn
        dark
        flat
        @click="sb.snackbar = false"
      >
        ОК
      </v-btn>
    </v-snackbar>





<v-card-text    >


  <v-text-field v-model='newProc.name' color="#4A76A8"    label="Название автообновления" clearable></v-text-field>







<div v-if="modals.creator">
<v-subheader> <v-icon  color="orange">mdi-flash</v-icon>  <h3 style="color:orange;margin-left:5px">Тип активности</h3></v-subheader>


<v-select
 v-model = 'newProc.selectedType'
 :items="newProc.typeList"
 item-text = 'procName'
 item-value = 'procType'
 label="Выберите тип активности"
>

</v-select>
</div>



<!-- Див активность сообществ -->
<div v-if="newProc.selectedType == 'groups'">
<v-subheader>    <v-icon  color="orange">mdi-account-group</v-icon>  <h3 style="color:orange;margin-left:5px">  Список источников   </h3></v-subheader>
<div ><v-checkbox  v-model='newProc.typeList[0].selectAllGroups'  @change="selectAllGroups($event)" label="Выбрать все сообщества ?"></v-checkbox></div>
<v-autocomplete
            v-model="newProc.typeList[0].selectedGroups"
            no-data-text = "Нет сообществ для выбора"
            :items="newProc.typeList[0].groupsAll"
            hide-selected
            chips
            color="#4A76A8"
            label="Выберите одно или несколько сообществ"
            item-text="name"
            item-value="id_of_group"
            multiple
          >
          <template
           slot="selection"
           slot-scope="data"
         >
           <v-chip

             :selected="data.selected"
             close
             class="chip--select-multi"
             @input="removeSelectedGroup(data.item)"
           >
             <v-avatar>
               <img :src="data.item.photo_50">
             </v-avatar>
             {{ data.item.name }}
           </v-chip>
         </template>

         <template
           slot="item"
           slot-scope="data"
         >
           <template v-if="typeof data.item !== 'object'">
             <v-list-tile-content v-text="data.title"></v-list-tile-content>
           </template>
           <template v-else>
             <v-list-tile-avatar>
               <img :src="data.item.photo_50">
             </v-list-tile-avatar>
             <v-list-tile-content>
               <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
             </v-list-tile-content>
           </template>
         </template>
          </v-autocomplete>

<v-subheader>    <v-icon  color="orange">mdi-tune</v-icon>  <h3 style="color:orange;margin-left:5px">Настройки обновлений активности</h3></v-subheader>
<div ><v-checkbox  v-model='newProc.typeList[0].recordResourceInfoNewIn' label="Запоминать куда подписался?"></v-checkbox></div>
<div ><v-checkbox  v-model='newProc.typeList[0].recordResourceInfoNewOut' label="Запоминать откуда отписался?"></v-checkbox></div>
<div ><v-checkbox  v-model='newProc.reactOnNewFollowers' label="Реагировать на новые подписки ?"></v-checkbox></div>
<div ><v-checkbox  v-model='newProc.reactOnNewFollowersOut' label="Реагировать на отписки ?"></v-checkbox></div>
<v-slider thumb-label="always" v-model="newProc.sensor" persistent-hint hint="Укажите время задержки в секундах" min="2" max="300" label="Задержка (сек.)"  ></v-slider>
<v-subheader> <v-icon  color="orange">mdi-export</v-icon>  <h3 style="color:orange;margin-left:5px">Экспорт подписок и отписок</h3></v-subheader>

<v-autocomplete
            v-model="newProc.typeList[0].selectedTasksForNewFollowers"
            no-data-text = "Нет заданий для выбора"
            :items="newProc.typeList[0].tasksAllForNewFollowers"
            hide-selected
            chips
            color="#4A76A8"
            label="Выберите задания для экспорта новых подписчиков"
            item-text="name"
            item-value="task_id"
            multiple
          >
          <template
           slot="selection"
           slot-scope="data"
         >
           <v-chip

             :selected="data.selected"
             close
             class="chip--select-multi"
             @input="removeSelectedTaskForNewFollowers(data.item)"
           >
             <v-avatar>
               <v-icon>mdi-account-multiple</v-icon>
             </v-avatar>
             {{ data.item.name }}
           </v-chip>
         </template>

         <template
           slot="item"
           slot-scope="data"
         >
           <template v-if="typeof data.item !== 'object'">
             <v-list-tile-content v-text="data.title"></v-list-tile-content>
           </template>
           <template v-else>
             <v-list-tile-avatar>
               <v-icon>mdi-account-multiple</v-icon>
             </v-list-tile-avatar>
             <v-list-tile-content>
               <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
             </v-list-tile-content>
           </template>
         </template>
          </v-autocomplete>


          <v-autocomplete
                      v-model="newProc.typeList[0].selectedTasksForNewFollowersOut"
                      no-data-text = "Нет заданий для выбора"
                      :items="newProc.typeList[0].tasksAllForNewFollowersOut"
                      hide-selected
                      chips
                      color="#4A76A8"
                      label="Выберите задания для экспорта новых отписок"
                      item-text="name"
                      item-value="task_id"
                      multiple
                    >
                    <template
                     slot="selection"
                     slot-scope="data"
                   >
                     <v-chip

                       :selected="data.selected"
                       close
                       class="chip--select-multi"
                       @input="removeSelectedTaskForNewFollowersOut(data.item)"
                     >
                       <v-avatar>
                         <v-icon>mdi-account-multiple</v-icon>
                       </v-avatar>
                       {{ data.item.name }}
                     </v-chip>
                   </template>

                   <template
                     slot="item"
                     slot-scope="data"
                   >
                     <template v-if="typeof data.item !== 'object'">
                       <v-list-tile-content v-text="data.title"></v-list-tile-content>
                     </template>
                     <template v-else>
                       <v-list-tile-avatar>
                         <v-icon>mdi-account-multiple</v-icon>
                       </v-list-tile-avatar>
                       <v-list-tile-content>
                         <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                       </v-list-tile-content>
                     </template>
                   </template>
                    </v-autocomplete>
</div>  <!-- Закрывает див  активности сообществ -->












<!-- Див активность страниц -->
<div v-if="newProc.selectedType == 'pages'">
<v-subheader>    <v-icon  color="orange">mdi-account-group</v-icon>  <h3 style="color:orange;margin-left:5px">Список сообществ </h3></v-subheader>
<div ><v-checkbox v-model='newProc.typeList[1].selectAllPages'   @change="selectAllPages($event)" label="Выбрать все страницы ?"></v-checkbox></div>
<v-autocomplete
            v-model="newProc.typeList[1].selectedPages"
            no-data-text = "Нет страниц для выбора"
            :items="newProc.typeList[1].pagesAll"
            hide-selected
            chips
            color="#4A76A8"
            label="Выберите одну или несколько страниц"
            item-text="first_name"
            item-value="vk_id"
            multiple
          >
          <template
           slot="selection"
           slot-scope="data"
         >
           <v-chip

             :selected="data.selected"
             close
             class="chip--select-multi"
             @input="removeSelectedPage(data.item)"
           >
             <v-avatar>
               <img :src="data.item.photo_50">
             </v-avatar>
             {{ data.item.first_name }} {{data.item.last_name}}
           </v-chip>
         </template>

         <template
           slot="item"
           slot-scope="data"
         >
           <template v-if="typeof data.item !== 'object'">
             <v-list-tile-content v-text="data.first_name"></v-list-tile-content>
           </template>
           <template v-else>
             <v-list-tile-avatar>
               <img :src="data.item.photo_50">
             </v-list-tile-avatar>
             <v-list-tile-content>
               <v-list-tile-title>{{data.item.first_name}} {{data.item.last_name}}</v-list-tile-title>
             </v-list-tile-content>
           </template>
         </template>
          </v-autocomplete>

<v-subheader>    <v-icon  color="orange">mdi-tune</v-icon>  <h3 style="color:orange;margin-left:5px">Настройки обновлений активности</h3></v-subheader>
<div ><v-checkbox  v-model='newProc.reactOnNewFollowers' label="Реагировать на новые подписки ?"></v-checkbox></div>
<div ><v-checkbox  v-model='newProc.reactOnNewFollowersOut' label="Реагировать на отписки ?"></v-checkbox></div>
<v-slider thumb-label="always" v-model="newProc.sensor" persistent-hint hint="Укажите время задержки в секундах" min="2" max="300" label="Задержка (сек.)"  ></v-slider>
<v-subheader> <v-icon  color="orange">mdi-export</v-icon>  <h3 style="color:orange;margin-left:5px">Экспорт обновлений</h3></v-subheader>

<v-autocomplete
            v-model="newProc.typeList[1].selectedTasksForNewFollowersPages"
            no-data-text = "Нет заданий для выбора"
            :items="newProc.typeList[1].tasksAllForNewFollowersPages"
            hide-selected
            chips
            color="#4A76A8"
            label="Выберите задания для экспорта 'Новые подписчики'"
            item-text="name"
            item-value="task_id"
            multiple
          >
          <template
           slot="selection"
           slot-scope="data"
         >
           <v-chip

             :selected="data.selected"
             close
             class="chip--select-multi"
             @input="removeSelectedTaskForNewFollowersPages(data.item)"
           >
             <v-avatar>
               <v-icon>mdi-account-multiple</v-icon>
             </v-avatar>
             {{ data.item.name }}
           </v-chip>
         </template>

         <template
           slot="item"
           slot-scope="data"
         >
           <template v-if="typeof data.item !== 'object'">
             <v-list-tile-content v-text="data.title"></v-list-tile-content>
           </template>
           <template v-else>
             <v-list-tile-avatar>
               <v-icon>mdi-account-multiple</v-icon>
             </v-list-tile-avatar>
             <v-list-tile-content>
               <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
             </v-list-tile-content>
           </template>
         </template>
          </v-autocomplete>


          <v-autocomplete
                      v-model="newProc.typeList[1].selectedTasksForNewFollowersOutPages"
                      no-data-text = "Нет заданий для выбора"
                      :items="newProc.typeList[1].tasksAllForNewFollowersOutPages"
                      hide-selected
                      chips
                      color="#4A76A8"
                      label="Выберите задания для экспорта 'Новые отписки'"
                      item-text="name"
                      item-value="task_id"
                      multiple
                    >
                    <template
                     slot="selection"
                     slot-scope="data"
                   >
                     <v-chip

                       :selected="data.selected"
                       close
                       class="chip--select-multi"
                       @input="removeSelectedTaskForNewFollowersOutPages(data.item)"
                     >
                       <v-avatar>
                         <v-icon>mdi-account-multiple</v-icon>
                       </v-avatar>
                       {{ data.item.name }}
                     </v-chip>
                   </template>

                   <template
                     slot="item"
                     slot-scope="data"
                   >
                     <template v-if="typeof data.item !== 'object'">
                       <v-list-tile-content v-text="data.title"></v-list-tile-content>
                     </template>
                     <template v-else>
                       <v-list-tile-avatar>
                         <v-icon>mdi-account-multiple</v-icon>
                       </v-list-tile-avatar>
                       <v-list-tile-content>
                         <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                       </v-list-tile-content>
                     </template>
                   </template>
                    </v-autocomplete>



                    <v-autocomplete
                                v-model="newProc.typeList[1].selectedTasksForNewFriendsPages"
                                no-data-text = "Нет заданий для выбора"
                                :items="newProc.typeList[1].tasksAllForNewFriendsPages"
                                hide-selected
                                chips
                                color="#4A76A8"
                                label="Выберите задания для экспорта 'Новые друзья'"
                                item-text="name"
                                item-value="task_id"
                                multiple
                              >
                              <template
                               slot="selection"
                               slot-scope="data"
                             >
                               <v-chip

                                 :selected="data.selected"
                                 close
                                 class="chip--select-multi"
                                 @input="removeSelectedTasksForNewFriendsPages(data.item)"
                               >
                                 <v-avatar>
                                   <v-icon>mdi-account-multiple</v-icon>
                                 </v-avatar>
                                 {{ data.item.name }}
                               </v-chip>
                             </template>

                             <template
                               slot="item"
                               slot-scope="data"
                             >
                               <template v-if="typeof data.item !== 'object'">
                                 <v-list-tile-content v-text="data.title"></v-list-tile-content>
                               </template>
                               <template v-else>
                                 <v-list-tile-avatar>
                                   <v-icon>mdi-account-multiple</v-icon>
                                 </v-list-tile-avatar>
                                 <v-list-tile-content>
                                   <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                 </v-list-tile-content>
                               </template>
                             </template>
                              </v-autocomplete>




                              <v-autocomplete
                                          v-model="newProc.typeList[1].selectedTasksForNewFriendsOutPages"
                                          no-data-text = "Нет заданий для выбора"
                                          :items="newProc.typeList[1].tasksAllForNewFriendsOutPages"
                                          hide-selected
                                          chips
                                          color="#4A76A8"
                                          label="Выберите задания для экспорта 'Удалили из друзей'"
                                          item-text="name"
                                          item-value="task_id"
                                          multiple
                                        >
                                        <template
                                         slot="selection"
                                         slot-scope="data"
                                       >
                                         <v-chip

                                           :selected="data.selected"
                                           close
                                           class="chip--select-multi"
                                           @input="removeSelectedTasksForNewFriendsOutPages(data.item)"
                                         >
                                           <v-avatar>
                                             <v-icon>mdi-account-multiple</v-icon>
                                           </v-avatar>
                                           {{ data.item.name }}
                                         </v-chip>
                                       </template>

                                       <template
                                         slot="item"
                                         slot-scope="data"
                                       >
                                         <template v-if="typeof data.item !== 'object'">
                                           <v-list-tile-content v-text="data.title"></v-list-tile-content>
                                         </template>
                                         <template v-else>
                                           <v-list-tile-avatar>
                                             <v-icon>mdi-account-multiple</v-icon>
                                           </v-list-tile-avatar>
                                           <v-list-tile-content>
                                             <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                           </v-list-tile-content>
                                         </template>
                                       </template>
                                        </v-autocomplete>






                                        <v-autocomplete
                                                    v-model="newProc.typeList[1].selectedTasksForNewFriendsOutBySelfPages"
                                                    no-data-text = "Нет заданий для выбора"
                                                    :items="newProc.typeList[1].tasksAllForNewFriendsOutBySelfPages"
                                                    hide-selected
                                                    chips
                                                    color="#4A76A8"
                                                    label="Выберите задания для экспорта 'Удалились из друзей'"
                                                    item-text="name"
                                                    item-value="task_id"
                                                    multiple
                                                  >
                                                  <template
                                                   slot="selection"
                                                   slot-scope="data"
                                                 >
                                                   <v-chip

                                                     :selected="data.selected"
                                                     close
                                                     class="chip--select-multi"
                                                     @input="removeSelectedTasksForNewFriendsOutBySelfPages(data.item)"
                                                   >
                                                     <v-avatar>
                                                       <v-icon>mdi-account-multiple</v-icon>
                                                     </v-avatar>
                                                     {{ data.item.name }}
                                                   </v-chip>
                                                 </template>

                                                 <template
                                                   slot="item"
                                                   slot-scope="data"
                                                 >
                                                   <template v-if="typeof data.item !== 'object'">
                                                     <v-list-tile-content v-text="data.title"></v-list-tile-content>
                                                   </template>
                                                   <template v-else>
                                                     <v-list-tile-avatar>
                                                       <v-icon>mdi-account-multiple</v-icon>
                                                     </v-list-tile-avatar>
                                                     <v-list-tile-content>
                                                       <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                                     </v-list-tile-content>
                                                   </template>
                                                 </template>
                                                  </v-autocomplete>
</div>  <!-- Закрывает див  активности страниц -->





<div v-if="newProc.selectedType == 'procs'">  <!-- Открываем див  обновления процессов -->
<v-slider thumb-label="always" v-model="newProc.sensor" persistent-hint hint="Укажите время задержки в секундах" min="2" max="300" label="Задержка (сек.)"  ></v-slider>
<v-switch  v-model="newProc.typeList[2].selectAllBindings"  label="Обновлять взаимно связанные процессы ?"></v-switch>
<v-subheader>    <v-icon  color="orange">mdi-content-save</v-icon>  <h3 style="color:orange;margin-left:5px">Процессы для обновления</h3></v-subheader>

<div  v-if="modals.params" v-for="item in newProc.typeList[2].procsAll">

  <div>
    <v-layout row style="margin-bottom:15px">
      <div style="margin-right:15px">
    <v-icon v-if="item.content_type == 'pages'"  large color="#273C51">mdi-account-search</v-icon>
    <v-icon v-else-if="item.content_type == 'groups'"  large color="green">mdi-account-group</v-icon>
    <v-icon v-else-if="item.content_type == 'topics'"  large color="yellow">mdi-message-reply-text</v-icon>
    <v-icon v-else-if="item.content_type == 'videos'"  large color="red">mdi-youtube</v-icon>
    <v-icon v-else-if="item.content_type == 'posts'"  large color="pink">mdi-comment-multiple-outline</v-icon>
    <v-icon v-else  large color="red">mdi-alert-circle</v-icon>
     </div>
<v-flex>
<div>  <span style="font-size:1.2em;font-weight:bold; color:#4A76A8"> {{ item.title   }}  </span> </div>
<div>  <span style="color:#757575"> {{item.title_desc   }}  </span> </div>
</v-flex>
<div v-if="item.subscribers">
<v-btn v-if="!item.subscribers.indexOf(procs.selected.real_id)" @click="unSelectProc(item)" flat small color="#4A76A8" style="text-transform:none !important">Отменить </v-btn>
<v-btn v-if="item.subscribers.indexOf(procs.selected.real_id)"  @click="selectProc(item)" class="white--text" small color="#4A76A8" style="text-transform:none !important">Выбрать </v-btn>
</div>
    </v-layout>
  </div>


</div>

<v-layout v-if="modals.creator">
<div>
Список процессов для выбора будет доступен после создания данного процесса, в параметрах процесса.
</div>
</v-layout>


</div>  <!-- Закрывает див  обновления процессов -->





<v-btn v-if="modals.creator" :loading="newProc.loading" @click="createProc('new')" color="#4A76A8"    flat   block>
  Создать автообновление
</v-btn>

<v-btn v-if="modals.params" :loading="newProc.loading" @click="createProc('update')" color="#4A76A8"    flat   block>
  Сохранить изменения
</v-btn>


</v-card-text>






  </v-card>




</template>

<script>

import axios from 'axios'
export default {
 components:{},
 props: ['modals','procs','newProc','base'],
  data () {
    return {
sb:{
snackbar: false,
color: 'success',
text: ''
},



    }
  },

methods: {
createProc(createType){
  let updateId
  let realId

  if(createType == "update"){
    updateId = this.procs.selected.id
    realId = this.procs.selected.real_id
  } else updateId = false


  this.newProc.loading = true
  this.newProc.typeList[0].groupsAll = []
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/fastupdate/create_proc.php', {
       method: 'POST',
       data: {
         updateId,
         realId,
         info: this.newProc,
         fullState: ""   //JSON.stringify(this.newProc)
       }
     })
     .then( response => {
       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/fastupdate/get_procs.php', {
            method: 'GET',
            data: {
              check: 1,
            }
          })
          .then( response => {
            this.procs.items = response.data
            this.modals.creator = false
            this.modals.params = false
            this.newProc.loading = false
            this.$store.dispatch('changeCounters')
          })

     })
},

  close(){
    this.modals.creator = false
  },


selectProc(item){

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/new_sub.php',{
  method: 'POST',
  data: {
    proccesId : item.process_id,
    saberType : "activiti",
    saberId : this.procs.selected.real_id,
    mode: 'sub'
  }
}).then(()=>{
  item.subscribers = []
  item.subscribers.push(this.procs.selected.real_id)
})



},

unSelectProc(item){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/new_sub.php',{
    method: 'POST',
    data: {
      proccesId : item.process_id,
      saberType : "activiti",
      saberId : this.procs.selected.real_id,
      mode: 'unSub'
    }
  }).then(()=>{
    item.subscribers.splice(item.subscribers.indexOf(this.procs.selected.real_id),1)
  })

},













removeSelectedTaskForNewFollowers (item) {
const index = this.newProc.typeList[0].selectedTasksForNewFollowers.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[0].selectedTasksForNewFollowers.splice(index, 1)
},
removeSelectedTaskForNewFollowersOut (item) {
const index = this.newProc.typeList[0].selectedTasksForNewFollowersOut.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[0].selectedTasksForNewFollowersOut.splice(index, 1)
},


removeSelectedTaskForNewFollowersPages (item) {
const index = this.newProc.typeList[1].selectedTasksForNewFollowersPages.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[1].selectedTasksForNewFollowersPages.splice(index, 1)
},
removeSelectedTaskForNewFollowersOutPages (item) {
const index = this.newProc.typeList[1].selectedTasksForNewFollowersOutPages.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[1].selectedTasksForNewFollowersOutPages.splice(index, 1)
},
removeSelectedTasksForNewFriendsPages (item) {
const index = this.newProc.typeList[1].selectedTasksForNewFriendsPages.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[1].selectedTasksForNewFriendsPages.splice(index, 1)
},
removeSelectedTasksForNewFriendsOutPages (item) {
const index = this.newProc.typeList[1].selectedTasksForNewFriendsOutPages.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[1].selectedTasksForNewFriendsOutPages.splice(index, 1)
},
removeSelectedTasksForNewFriendsOutBySelfPages (item) {
const index = this.newProc.typeList[1].selectedTasksForNewFriendsOutBySelfPages.indexOf(item.task_id)
if (index >= 0) this.newProc.typeList[1].selectedTasksForNewFriendsOutBySelfPages.splice(index, 1)
},


selectAllGroups(event){
if(event){
  //this.newProc.typeList[0].selectedGroups = this.newProc.typeList[0].groupsAll
  this.newProc.typeList[0].selectedGroups = this.newProc.typeList[0].groupsAll.map((item)=>{return item.id_of_group})
} else this.newProc.typeList[0].selectedGroups = []

},
selectAllPages(event){
if(event){
  this.newProc.typeList[1].selectedPages = this.newProc.typeList[1].pagesAll
} else this.newProc.typeList[1].selectedPages = []

},

removeSelectedGroup (item) {
const index = this.newProc.typeList[0].selectedGroups.indexOf(item.id_of_group)
if (index >= 0) this.newProc.typeList[0].selectedGroups.splice(index, 1)
},
removeSelectedPage (item) {
const index = this.newProc.typeList[1].selectedPages.indexOf(item.vk_id)
if (index >= 0) this.newProc.typeList[1].selectedPages.splice(index, 1)
},
},



computed: {
 activeParams(){
   if(true){
      this.newProc.selectedType =  this.procs.selected.selected_type
      this.newProc.name = this.procs.selected.name
      this.newProc.sensor = this.procs.selected.params.sensor
      this.newProc.reactOnNewFollowers = this.procs.selected.params.reactOnNewFollowers
      this.newProc.reactOnNewFollowersOut = this.procs.selected.params.reactOnNewFollowersOut


    if(this.procs.selected.selected_type == 'groups'){
       this.newProc.typeList[0].selectAllGroups = this.procs.selected.params.selectAllGroups
       this.newProc.typeList[0].selectedGroups = this.procs.selected.params.selectedGroups
       this.newProc.typeList[0].selectedTasksForNewFollowers = this.procs.selected.params.selectedTasksForNewFollowers
       this.newProc.typeList[0].selectedTasksForNewFollowersOut = this.procs.selected.params.selectedTasksForNewFollowersOut

       this.newProc.typeList[0].recordResourceInfoNewIn = this.procs.selected.params.recordResourceInfoNewIn
       this.newProc.typeList[0].recordResourceInfoNewOut = this.procs.selected.params.recordResourceInfoNewOut
     }
   if(this.procs.selected.selected_type == 'pages'){
       this.newProc.typeList[1].selectAllPages = this.procs.selected.params.selectAllPages
       this.newProc.typeList[1].selectedPages = this.procs.selected.params.selectedPages
     }
     if(this.procs.selected.selected_type == 'procs'){

         this.newProc.typeList[2].selectAllBindings = this.procs.selected.params.selectAllBindings

       }


      return 'Параметры:' + ' ' + this.procs.selected.name}
 },




},



}

</script>

<style    >

</style>
